/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import ProductBundleUpload from "../../../assets/File/ProductBundleUpload.xlsx";
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import ReactPaginate from 'react-paginate'
import DPSwitch from 'framework/components/DPSwitch'

const ProductBundleContent = ({
    CodeValue,
    CodeonChange,
    DescValue,
    DescOnChange,
    disabled,
    SwonChange,
    ActiveSw,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    disabledCode,
    CodeOnBlur,
    ErrorMsg,
    menuName,
    onButtonClick,
    btnDisable,
    SearchDisable,
    showFileUpload,
    valueUpload,
    itemList,
    GenerateItemList,
    autoCode,
    GenerateBTNDisabled,
    ApiURL,
    menuCode,
    DeleteItems,
    isStockCodeWise,
    setIsStockCodeWise
}) => {

    const [groupFilter, SetGroupFilter] = useState('a')

    const defaultSorted = [
        {
            dataField: "id",
            order: "asc",
        },
    ]

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={6} className="mb-4-sm">
                                <DPTextBoxButton
                                    rowClass="mb-4-sm"
                                    labelText="Code *"
                                    textType="text"
                                    maxLength="5"
                                    value={CodeValue}
                                    onChange={CodeonChange}
                                    onBlur={CodeOnBlur}
                                    disabled={disabled == true ? disabled : disabledCode}
                                    onButtonClick={onButtonClick}
                                    btnDisable={disabled == true ? disabled : btnDisable}
                                    placeholder={autoCode}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Description *"
                                    textType="text"
                                    maxLength="50"
                                    value={DescValue}
                                    onChange={DescOnChange}
                                    disabled={disabled}
                                />
                                <Row>
                                    <Col sm={3}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Active
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SwonChange}
                                            checked={ActiveSw}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={3}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Is StockCode Wise
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={setIsStockCodeWise}
                                            checked={isStockCodeWise}
                                            disabled={disabled ? true : itemList.length > 0 ? true : false}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm">
                                <Button
                                    onClick={() => {
                                        modelTrigger()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                    disabled={SearchDisable}
                                >
                                    <i
                                        className="mdi mdi-search-web"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </Button>
                            </Col>
                            <Col sm={12} md={2} className="mb-4-sm">
                                <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <input
                                            id="file"
                                            type="file"
                                            onChange={showFileUpload}
                                            value={valueUpload}
                                            disabled={disabled}
                                            accept=".xlsx, .xls, .csv"
                                            style={{ display: "none" }}
                                        />

                                        <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: disabled == true ? "0.5" : "1" }}>
                                            <span >
                                                <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                                            </span>
                                        </label></li>

                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <a href={ProductBundleUpload} download="ProductBundleUpload" data-tip title="Master excel format download"
                                            style={{ pointerEvents: disabled ? 'none' : '', }} >
                                            <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabled == true ? "0.5" : "1" }}></img>
                                        </a></li>
                                </ul>
                            </Col>
                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={[]}
                                defaultSorted={defaultSorted}
                                mainTitle={`${menuName} Search`}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"PROMOSKU"}
                                MenuCode={menuCode}
                                KeyVal={'PROMO'}
                                searchBy={'PSKU_CODE'}
                                FilterStr={groupFilter}
                            />
                        </Row>
                        <Row>
                            <Col sm={12} md={8} className="mb-4-sm">
                                <TableWithPagination
                                    DataTables={itemList}
                                />

                            </Col>
                            <Col sm={12} md={2} className="mb-4-sm text-end">
                                <Button
                                    onClick={() => {
                                        GenerateItemList()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                    disabled={GenerateBTNDisabled}
                                >
                                    <i className="mdi mdi-plus" style={{ fontSize: "12px" }}></i>
                                    Add Excel Items
                                </Button>

                            </Col>
                            <Col sm={12} md={2} className="mb-4-sm ">
                                <Button
                                    onClick={() => {
                                        DeleteItems()
                                    }}
                                    color="danger"
                                    className="btn-sm"
                                    disabled={disabled}
                                >
                                    <i className="mdi mdi-minus" style={{ fontSize: "12px" }}></i>
                                    Delete Items
                                </Button>

                            </Col>
                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}

export default ProductBundleContent



const TableWithPagination = ({ DataTables, handleSwitchChanges, change, disabled }) => {

    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage] = useState(20)

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = DataTables.slice(indexOfFirstPost, indexOfLastPost)

    useEffect(() => {
        setCurrentPage(1)
    }, [change])

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    return (
        <React.Fragment>
            <Row>
                <table className="custom-table table-bordered table-sm rounded">
                    <thead className='table-secondary'>
                        <tr>
                            <th style={{ width: "5%" }}>Code</th>
                            <th style={{ width: "20%" }}>Description</th>
                            <th style={{ width: "5%" }}>Disc Per</th>
                            <th style={{ width: "5%" }}>Disc Amt</th>

                        </tr>
                    </thead>
                    <tbody className='special-tbody'>
                        {currentPosts.map((values, index) => {
                            return (
                                <tr className='no-pointer no-hover' key={values.id}>
                                    <td>{values.code}</td>
                                    <td>{values.name}</td>
                                    <td>{values.discPer}</td>
                                    <td>{values.discAmt}</td>
                                </tr>
                            )
                        })
                        }
                    </tbody>
                </table>
            </Row>
            <Row className='mt-1'>
                <Col md="12">
                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(DataTables.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-end pagination-sm'}
                    />
                </Col>
            </Row>

        </React.Fragment>
    )
}